export const API_CONFIG = {
  BASE_URL: 'https://api.singularface.com',
  ENDPOINTS: {
    RECOGNITION_SEARCH: '/recognition/search',
    RECOGNITION_VERIFY: '/recognition/verify',
    USERS: '/users',
    LOGIN: '/user-admins/login',
    API_KEYS: '/api-keys',
  },
}; 